var render = function render(){var _vm=this,_c=_vm._self._c;return _c('HyFLoader',{attrs:{"variant":_vm.backdrop ? 'fullscreen' : 'inline',"paused":_vm.error}},[(_vm.message)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.message)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }